import React from "react";
import { cn } from "../../lib/utils";

interface FormCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The main title/label for the card
   */
  title: string;
  /**
   * Optional description/subtitle text
   */
  description?: string;
}

/**
 * A reusable card component for form sections with consistent styling.
 * Used in settings/profile pages for grouping related form controls.
 *
 * @example
 * <FormCard title="Avatar" description="Choose your character">
 *   <AvatarSelection ... />
 * </FormCard>
 */
const FormCard = React.forwardRef<HTMLDivElement, FormCardProps>(
  ({ title, description, className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "w-full max-w-md bg-form-card-bg shadow-basic border-2 border-black p-3",
          className
        )}
        {...props}
      >
        <div className="mb-2">
          <div className="text-lg font-semibold">{title}</div>
          {description && (
            <div className="text-md opacity-75">{description}</div>
          )}
        </div>
        {children}
      </div>
    );
  }
);

FormCard.displayName = "FormCard";

export default FormCard;
